import config from './config';
import {hasTrackingConsent} from './cookieConsent';

const sendAnalyticsEvent = (eventType, eventData = {}) => {
    if (!hasTrackingConsent()) return;
    if (typeof window.fbq === 'function') {
        try { window.fbq('track', eventType, eventData); }
        catch (error) { console.error('Failed to send event to Facebook Pixel:', error); }
    }
    if (typeof window.ym === 'function') {
        try { window.ym(config.yandexMetrikaId, 'reachGoal', eventType); }
        catch (error) { console.error('Failed to send event to Metrika:', error); }
    }
};

const getAnalyticsContext = (search, referrer) => {
    if (!hasTrackingConsent()) return {utmParams: null, referrer: null};

    const utmParams = {};
    for (const [key, value] of new URLSearchParams(search).entries()) {
        if (key.startsWith('utm_')) utmParams[key] = value;
    }

    return {
        utmParams: Object.keys(utmParams).length > 0 ? utmParams : null,
        referrer: referrer || null,
    };
};

export {sendAnalyticsEvent, getAnalyticsContext};
